import ApiPermisos from '../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    errorMsj: '',
    categories: [],
    loading: false,
    loadingTips: false,
    tipsConfig: {
      id: null,
      name: null,
      title: null,
      general: null
    },
    propinasGeneral: [],
    listpointsales: {
      data: {}
    },
    listzonesales: {
      data: {}
    },
    zones: [],
    listtipsdaily: {
      data: {}
    },
    listLineDeals: {},
    selectPointSales:[]
  },
  getters: {
    getAllPropinasGeneral: (state) =>{
      return state.propinasGeneral;
    },

    getAllListPointSales: (state) =>{
      return state.listpointsales;
    },

    getAllZones: (state) =>{
      return state.zones;
    },

    getAllListTipsdaily: (state) =>{
      return state.listtipsdaily;
    },

    // Formatear moneda  
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    
  },
  mutations: {
    setPropinasGeneral: (state, propinas) => {
      state.propinasGeneral = [];
      state.propinasGeneral = propinas;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },

    setLoadingTips: (state, loading) => {
      state.loadingTips = loading;
    },

    setListPointSales: (state, propinas) => {
      state.listpointsales = [];
      state.listpointsales = propinas;
    },

    setSelectPointSales: (state, pdvs) => {
      state.selectPointSales = [];
      state.selectPointSales = pdvs;
    },

    setListZoneSales: (state, zonas) => {
      state.listzonesales = [];
      state.listzonesales = zonas;
    },

    setTipsConfig: (state, config) => {
      state.tipsConfig=config;
    },

    setlisttipsdaily: (state, tipsdaily) => {
      state.listtipsdaily = [];

      let tipsdaily_ = []
      tipsdaily_ = tipsdaily.data.data.map(function(element) {
        let elemento = {};

        let val = (element.close_value/1).toFixed(2).replace('.', ',');
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        elemento.close_value = val;

        val = (element.value_finish_collaborators/1).toFixed(2).replace('.', ',');
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        elemento.value_finish_collaborators = val;

        val = (element.value_finish_support_bags/1).toFixed(2).replace('.', ',');
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        elemento.value_finish_support_bags = val;

        elemento.date = element.date;
        elemento.id = element.id;

        return elemento;
      });
      
      tipsdaily.data.data = tipsdaily_;
      state.listtipsdaily = tipsdaily;
    },

    setListZones: (state, zones) => {
      state.zones = [];
      let zones_ = []
      zones_ = zones.map(function(element) {
        let elemento = {};
        elemento.value = element.id;
        elemento.text = element.name;
        return elemento;
      });

      state.zones = zones_;
    },

    setListLineDeals: (state, lineDeals) => {
      state.listLineDeals = [];
      state.listLineDeals = lineDeals;
    },

    
    
  },
  actions: {  
    // Setear datos del componente de propinas
    actSetComponentePropinas: async ({
      commit
    },data) => {
        commit('setLoadingTips', true);
        commit('setTipsConfig', data);
        commit('setLoadingTips', false);
        return data;
    },
    
     //Trae listado de las propinas general linea de negocio y diario
    actGetPropinasGeneral: async ({
      commit
    },data) => {
        commit('setLoadingTips', true);
        let response = {};
        switch (data.func) {
          case 'getTipsGeneral':
            // general
            response = await ApiPermisos.getTipsGeneral();
            break;
          case 'getTipsLineDeal':
            // Linea de negocio
            response = await ApiPermisos.getTipsLineDeal(data.data);
            break;
            case 'getTipsZone':
            // Zona
            response = await ApiPermisos.getTipsZone(data.data);
            break;
            
          case 'getTipsPointSale':
              // Por punto de venta
              response = await ApiPermisos.getTipsPointSale(data.data);
              break;
          case 'getTipsDaily':
            // Por dia y punto de venta
            response = await ApiPermisos.getTipsDaily(data.data);
            break;
        }
        
        if (response.error) {
            return response.error;
        }
        else{
          commit('setLoadingTips', false);
          commit('setPropinasGeneral', response);
        }
        return response;
    },

     //Lista un datatable para las propinas de los puntos de ventas por zona
     actGetPuntosVenta: async ({
      commit
    },data) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getlistPointSales(data.data, data.pro_point_sale_id);        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setListPointSales', response);
        }
        return response;
    },

     // Obtiene una lista para el select de los puntos de ventas por zonas
     actGetListPuntosVenta: async ({
      commit
    },id) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getPointSalesByLineDeal(id);        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setSelectPointSales', response);
        }
        return response;
    },

     //Lista un datatable para las propinas de las ventas por zona
     actGetZonasVenta: async ({
      commit
    },data) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getlistZoneSales(data.data, data.pro_point_sale_id);        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setListZoneSales', response);
        }
        return response;
    },

     //Lista un datatable para las propinas diarias de cada punto de venta
     actGetPuntosVentaDaily: async ({
      commit
    },data) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getlistPointSalesDaily(data.data);        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setlisttipsdaily', response);
        }
        return response;
    },

    // Obtener las zonas de las bodegas para listarlas
    actGetZonas: async ({
      commit
    },data) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getlistZones(data);        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setListZones', response.data);
        }
        return response;
    },


    // Obtener las lineas de negocio para listarlas
    actGetLineDeals: async ({
      commit
    }) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getlistDeals();        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setListLineDeals', response.data);
        }
        return response;
    },

    
    
  },
}